import React from 'react'
import ReactEcharts from "echarts-for-react";
import {convertDateFormat,getLastWeekDate,breakTitle} from "../Custom/Custom"

function SixtySevenBarChart({graphData,chartDetails}) {

    let graphAllData=graphData[0].GroupCodes;
    let payload=graphData[1].payload;
    let chartDataLength= graphAllData.length;
    let topFiveItemsObject={};
    let bottomFiveItemsObject={};

    if(chartDataLength>0){
      let currentWeekAndTop = [];
      let lastWeekAndTop = [];
      let lastMonthAndTop = [];
      let lastYearAndTop= [];
      let heightYearAndTop= [];
      let currentWeekAndBottom = [];
      let lastWeekAndBottom = [];
      let lastMonthAndBottom = [];
      let lastYearAndBottom = [];
      let heightYearAndBottom = [];
    


      graphAllData.forEach((monthData) => {
        if (Array.isArray(monthData)) {
            monthData.forEach((item) => {
            if (item.Top === "Top") {

              if (item.Current_Week_Price !== undefined) {
                  currentWeekAndTop.push(item);
              } else if (item.LAST_WEEK_PRICE !== undefined) {
                  lastWeekAndTop.push(item);
              } else if (item.LAST_MONTH_PRICE !== undefined) {
                  lastMonthAndTop.push(item);
              } else if (item.LAST_YEAR_PRICE !== undefined) {
                  lastYearAndTop.push(item);
              } else if (item.Hight_Price !== undefined) {
                  heightYearAndTop.push(item);
              }
          }
          if (item.Bottom === "Bottom") {

            if (item.Current_Week_Price !== undefined) {
              currentWeekAndBottom.push(item);
            } else if (item.LAST_WEEK_PRICE !== undefined) {
              lastWeekAndBottom.push(item);
            } else if (item.LAST_MONTH_PRICE !== undefined) {
              lastMonthAndBottom.push(item);
            } else if (item.LAST_YEAR_PRICE !== undefined) {
              lastYearAndBottom.push(item);
            } else if (item.Hight_Price !== undefined) {
              heightYearAndBottom.push(item);
            }
          }
        });
      }
    });

    currentWeekAndTop = currentWeekAndTop.sort((a, b) => a.Percentage - b.Percentage);

  //  Top 5 items code***
    let currentWeekDataTop = [];
    let topFiveToolTip=[]
    let topFiveyAxisData=[]; 
    let itemCodesArray=[];
    currentWeekAndTop.forEach((item) => {
        currentWeekDataTop.push({"value":item.Percentage
      ,"price":item.Current_Week_Price,"date":"00-00-0000"},);
      for(let i=0;i<heightYearAndTop.length;i++){
        if(item.ITEM_CODE===heightYearAndTop[i].ITEM_CODE){
            topFiveyAxisData.push(`${breakTitle(item.ITEM_NAME_HINDI)}-${item.ITEM_CODE}  (${item.ITEM_UNIT_NAME}) \n High Value- Rs. ${heightYearAndTop[i].Hight_Price} \n (${convertDateFormat(heightYearAndTop[i].CREATEDDATE)})`  )
        }
        
      }
      itemCodesArray.push(item.ITEM_CODE);
      topFiveToolTip.push(`${item.ITEM_NAME_HINDI}-${item.ITEM_CODE} (${item.ITEM_UNIT_NAME})`);
  
    })

    let lastWeekDataTop = [];
    itemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastWeekAndTop.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastWeekDataTop.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.LAST_WEEK_PRICE,
              "date": "00-00-0000"
          });
      }
    }); 

    let lastMonthDataTop = [];
    itemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastMonthAndTop.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastMonthDataTop.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.LAST_MONTH_PRICE,
              "date": "00-00-0000"
          });
      }
    });

    let lastYearDataTop = [];
    itemCodesArray.forEach((targetItemCode) => {
        const matchingItem = lastYearAndTop.find(item => item.ITEM_CODE === targetItemCode);
    
        if (matchingItem) {
            lastYearDataTop.push({
                "value": matchingItem.Percentage,
                "price": matchingItem.LAST_YEAR_PRICE,
                "date": "00-00-0000"
            });
        }
    });


    currentWeekAndBottom = currentWeekAndBottom.sort((a, b) => b.Percentage - a.Percentage);

      //  Bottom 5 items code
      let currentWeekDataBottom = [];
      let botomFiveToolTip=[]
      let bottomFiveyAxisData=[];
      let bottomitemCodesArray=[];
      currentWeekAndBottom.forEach((item) => {
          currentWeekDataBottom.push({"value":item.Percentage
        ,"price":item.Current_Week_Price,"date":"00-00-0000"},);
        for(let i=0;i<heightYearAndBottom.length;i++){
          if(item.ITEM_CODE===heightYearAndBottom[i].ITEM_CODE){
              bottomFiveyAxisData.push(`${breakTitle(item.ITEM_NAME_HINDI)}-${item.ITEM_CODE}  (${item.ITEM_UNIT_NAME}) \n High Value- Rs. ${heightYearAndBottom[i].Hight_Price} \n (${convertDateFormat(heightYearAndBottom[i].CREATEDDATE)})`  )
          }
          
        }
        bottomitemCodesArray.push(item.ITEM_CODE);
        botomFiveToolTip.push(`${item.ITEM_NAME_HINDI}-${item.ITEM_CODE} (${item.ITEM_UNIT_NAME})`);
    
      })


      let lastWeekDataBottom = [];
      bottomitemCodesArray.forEach((targetItemCode) => {
        const matchingItem = lastWeekAndBottom.find(item => item.ITEM_CODE === targetItemCode);
    
        if (matchingItem) {
          lastWeekDataBottom.push({
                "value": matchingItem.Percentage,
                "price": matchingItem.LAST_WEEK_PRICE,
                "date": "00-00-0000"
            });
        }
      });

      let lastMonthDataBottom = [];
      bottomitemCodesArray.forEach((targetItemCode) => {
        const matchingItem = lastMonthAndBottom.find(item => item.ITEM_CODE === targetItemCode);
    
        if (matchingItem) {
          lastMonthDataBottom.push({
                "value": matchingItem.Percentage,
                "price": matchingItem.LAST_MONTH_PRICE,
                "date": "00-00-0000"
            });
        }
      });

    let lastYearDataBottom = [];
    bottomitemCodesArray.forEach((targetItemCode) => {
      const matchingItem = lastYearAndBottom.find(item => item.ITEM_CODE === targetItemCode);
  
      if (matchingItem) {
        lastYearDataBottom.push({
              "value": matchingItem.Percentage,
              "price": matchingItem.LAST_YEAR_PRICE,
              "date": "00-00-0000"
          });
      }
   });

  const currentWeekName = `Current Week (${payload.current_week_date})`;
  const lastWeekName = `Last Week (${getLastWeekDate(payload.current_week_date)})`;
  const lastMonthName = `Last Month (${payload.last_month_date})`;
  const lastYearName = `Last Year (${payload.last_year_date})`;

  // Top Five Items Object 
   topFiveItemsObject = {
      title: {
        text: ''
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }, formatter: function(params) {
          let tooltipText = '';
          const dataIndex = params[0].dataIndex;
          const yAxisLabel = topFiveToolTip[dataIndex];
          tooltipText += yAxisLabel + '<br>';
    
          params.forEach(function(item) {
    
              const seriesName = item.seriesName;
              const value = item.value;
              const price = item.data.price;
            // Access the Y-axis label for the current data point
              tooltipText +=
                  '<div style="margin: 0px 0 0;line-height:1.8;"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                  item.color + ';"></span>' + seriesName + '  ' +
                  '<strong style="padding-left:30px;float:right;min-width:90px; ">' +
                  value + ' %</strong>' +
                  '<strong style="padding-left:30px;float:right"> Rs. ' +
                  price + '</strong></div>';
    
          });
    
          return tooltipText;
      }
      },
      legend: {},
      grid: {
        left: '5%',
        right: '5%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: {},
          }
      },
      xAxis: [{
        type: 'value',
        name: 'Percentage',
        nameLocation: 'middle',
        nameGap: 70,
        boundaryGap: [0, 0.10],
    
        axisLabel: {
            formatter: '{value} % ',
            align: 'center',
    
            textStyle: {
                fontSize: '10',
            },
        },
    }],
    yAxis: {
        type: 'category',
        name: '',
        nameLocation: 'middle',
        nameGap: 140,
        axisLabel: {
          textStyle: {
              lineHeight: 15,
          },
      },
        data:topFiveyAxisData
    },
    series: [{
          name: currentWeekName,
          type: 'bar',
          data:currentWeekDataTop
        },
        {
          name: lastWeekName,
          type: 'bar',
          data: lastWeekDataTop
        },
        {
          name: lastMonthName,
          type: 'bar',
          data: lastMonthDataTop
        },
        {
          name: lastYearName,
          type: 'bar',
          data: lastYearDataTop
        }
        ]
    };
  // Bottom Five Items Object 
   bottomFiveItemsObject = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }, formatter: function(params) {
            let tooltipText = '';
            const dataIndex = params[0].dataIndex;
            const yAxisLabel = botomFiveToolTip[dataIndex];
            tooltipText += yAxisLabel + '<br>';
      
            params.forEach(function(item) {
      
                const seriesName = item.seriesName;
                const value = item.value;
                const price = item.data.price;
              // Access the Y-axis label for the current data point
                tooltipText +=
                    '<div style="margin: 0px 0 0;line-height:1.8;"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' +
                    item.color + ';"></span>' + seriesName + '  ' +
                    '<strong style="padding-left:30px;float:right;min-width:90px; ">' +
                    value + ' %</strong>' +
                    '<strong style="padding-left:30px;float:right"> Rs. ' +
                    price + '</strong></div>';
      
            });
      
            return tooltipText;
        }
        },
        legend: {},
        grid: {
          left: '5%',
          right: '5%',
          bottom: '15%',
          containLabel: true
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
            }
        },
        xAxis: [{
          type: 'value',
          name: 'Percentage',
          nameLocation: 'middle',
          nameGap: 70,
          boundaryGap: [0, 0.10],
      
          axisLabel: {
              formatter: '{value} % ',
              align: 'center',
      
              textStyle: {
                  fontSize: '10',
              },
          },
      }],
      yAxis: {
          type: 'category',
          name: '',
          nameLocation: 'middle',
          nameGap: 140,
          axisLabel: {
            textStyle: {
                lineHeight: 15,
            },
        },
          data:bottomFiveyAxisData
      },
      series: [{
            name: currentWeekName,
            type: 'bar',
            data:currentWeekDataBottom
          },
          {
            name: lastWeekName,
            type: 'bar',
            data: lastWeekDataBottom
          },
          {
            name: lastMonthName,
            type: 'bar',
            data: lastMonthDataBottom
          },
          {
            name: lastYearName,
            type: 'bar',
            data: lastYearDataBottom
          }
          ]
  };  
 }
return (
    <>
     <div className="px-3">
      <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-6 mb-4 mt-3">
              {chartDetails.chart_type==="Sixty_Seven_Necessary_Chart" && 
              (`Price (in Rs.) of Sixty Seven Necessary Items Graph Report of current week, last week, last year and High Value with respect to corresponding current week(${payload.current_week_date})`)
              }
            
          </div>
      </div>
      <div className="row">
              <div className="col-xl-6 col-lg-12 col-md-4 col-sm-12 mb-3">
                <div className="card h-100">
                { (Object.keys(topFiveItemsObject).length) > 0 ?
                    <>
                    <div className="card-header bg-white">
                        <h6 className="fw-bold">Top 5 Items</h6>
                    </div>
                    <div className="card-body h-100">
                      {<ReactEcharts option={topFiveItemsObject} style={{height: '600px', width: '100%'}} />}
                    </div>
                    </>
                  :
                  <h4 className="p-3 text-center text-danger fw-bold">Data Not Found</h4>
                }
                </div>
            </div>

            {/*bottom 5 Items BarChart */}
            <div className="col-xl-6 col-lg-12 col-md-4 col-sm-12 mb-3">

              <div className="card h-100">
              { (Object.keys(topFiveItemsObject).length) > 0 ?
                <>
                <div className="card-header bg-white">
                    <h6 className="fw-bold">Bottom 5 Items</h6>
              </div> 
                <div className="card-body h-100">
                {<ReactEcharts option={bottomFiveItemsObject} style={{height: '600px', width: '100%'}} />}
              </div>
              </>
              :
              <h4 className="p-3 text-center text-danger fw-bold">Data Not Found</h4> 
            }    
              </div>
            </div>
      </div>
   </div>
    </>
  )
}

export default SixtySevenBarChart